import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=18bff738&scoped=true"
import script from "./Test.vue?vue&type=script&setup=true&lang=js"
export * from "./Test.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bff738",
  null
  
)

export default component.exports